import { styled } from "@mui/material/styles";

export const GlobalContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  maxWidth: "1440px",
  marginLeft: "auto",
  marginRight: "auto",
}));

export const MaxWidthContainer = styled("div")(({ theme }) => ({
  maxWidth: "875px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._700,
}));

export const ListContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "3rem",
  alignSelf: "stretch",
}));

export const PageContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: `-${theme.space._1000}`,
  gap: theme.space._700,
  padding: `0 ${theme.space._900} ${theme.space._900} ${theme.space._900}`,
  
  "@media (max-width: 992px)": {
    marginTop: `-${theme.space._800}`,
    gap: theme.space._600,
    padding: `0 ${theme.space._400} ${theme.space._400} ${theme.space._400}`,
  },
}));